module.exports = __webpack_public_path__ + "img/mufg.b232eea2.svg";